import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import { useMemoizedFn } from 'ahooks';
// import { Justify, Segment } from 'tea-component';
import { Justify } from 'tea-component';
import { isEqual } from 'lodash-es';
import GPSelectMultiple from '@gp/components/SelectMultiple';
import DropDownSelect from '@gp/components/DropDownSelect';
import { SELECT_PANEL_HEIGHT_WITHOUT_SEARCH_BOX } from '@gp/constants/const';
import { MANAGEMENT_SEGMENT_BOARD_GOVERNANCE } from '@gp/pages/StudioDashboard/StudioOverall/Tabs/Management/constants';

import type { IBaseProps } from '@home/types/common';
// import type { SegmentOption } from 'tea-component/lib/segment/SegmentOption';

import './index.scss';

export interface IStudioOverallManagementFilter {
  studio: string[];
  business_owner: string[];
  year: string;
}

export interface IStudioOverallManagementOptionsData {
  studios: any[];
  businesses: any[];
  dates: any[];
}

const sortOptions = function (data: any[]) {
  const res = data;
  // a-z排序
  data?.sort((a, b) => {
    let nameA = a?.text?.toUpperCase();
    let nameB = b?.text?.toUpperCase();
    // 数据结构可能是json字符串对象
    try {
      nameA = Object.values(JSON.parse(nameA))[0] || nameA;
    } catch (err) {
      // console.warn(err);
    }
    try {
      nameB = Object.values(JSON.parse(nameB))[0] || nameB;
    } catch (err) {
      // console.warn(err);
    }

    if (nameA === 'OTHERS') {
      return 1;
    }
    if (nameB === 'OTHERS') {
      return -1;
    }

    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    return 0;
  });

  return res;
};

export interface IStudioOverallManagementFilterProps extends IBaseProps {
  // segments: SegmentOption[];
  segmentId: string;
  // onSegmentChange?: (payload: string) => void;
  optionsData: IStudioOverallManagementOptionsData;
  loading: boolean;
  value?: IStudioOverallManagementFilter;
  onChange?: (payload: IStudioOverallManagementFilter, segmentId: string) => void;
}

const StudioOverallManagementFilter: React.FC<IStudioOverallManagementFilterProps> = (props) => {
  const {
    // segments,
    segmentId,
    // onSegmentChange,
    loading,
    optionsData,
    value: valueProps,
    onChange,
    className,
    style,
  } = props;

  const [value, setValue] = useState<IStudioOverallManagementFilter>({
    studio: [],
    business_owner: [],
    year: '',
  });

  const handleStudioChange = useMemoizedFn((payload: string[]) => {
    const valueTemp = { ...value, studio: payload };
    setValue(valueTemp);
    onChange?.(valueTemp, segmentId);
  });

  const handleBusinessChange = useMemoizedFn((payload: string[]) => {
    const valueTemp = { ...value, business_owner: payload };
    setValue(valueTemp);
    onChange?.(valueTemp, segmentId);
  });

  const handleYearChange = useMemoizedFn((payload: { value: string; options: { text: any; value: string; }[]; }) => {
    const valueTemp = { ...value, year: payload?.value };
    setValue(valueTemp);
    onChange?.(valueTemp, segmentId);
  });

  useEffect(() => {
    if (valueProps && !isEqual(valueProps, value)) {
      setValue({ ...valueProps });
    }
  }, [valueProps]);

  return (
    <Justify
      style={style}
      className={classnames(
        'dbg-studio-overall-key-information-filter font14 dbg-studio-overall-management-filter',
        className,
      )}
      left={
        <div className="dbg-studio-overall-management-filter-container" onClick={(e: any) => e?.stopPropagation()}>
          {/* <Segment
            className="dbg-common-segment segment-light"
            options={segments}
            value={segmentId}
            onChange={onSegmentChange}
          /> */}
          {segmentId === MANAGEMENT_SEGMENT_BOARD_GOVERNANCE && (
            <DropDownSelect
              className="dbg-studio-overall-management-filter-year-select"
              allOpt={{
                placeholder: `Please select Date`,
                disabled: loading,
                clearable: false,
                staging: false,
                listHeight: SELECT_PANEL_HEIGHT_WITHOUT_SEARCH_BOX,
                isValueControlled: true,
                values: value?.year,
                options: optionsData?.dates,
              }}
              onChange={handleYearChange}
            />
          )}
          <GPSelectMultiple
            label="BO"
            disabled={loading}
            searchable={true}
            options={sortOptions(optionsData?.businesses) || []}
            value={value?.business_owner}
            onChange={handleBusinessChange}
          />
          <GPSelectMultiple
            label="Studio"
            disabled={loading}
            searchable={true}
            options={sortOptions(optionsData?.studios) || []}
            value={value?.studio}
            onChange={handleStudioChange}
          />
        </div>
      }
    />
  );
};

export default React.memo(StudioOverallManagementFilter);
